exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.cardText {\n  overflow: auto;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n", "", {"version":3,"sources":["/Users/andy/org-project/warehouse_system_ui/src/components/PromotionWidget.vue"],"names":[],"mappings":";AAiIA;EACE,eAAe;EACf,sBAAsB;EACtB,sBAAsB;CACvB","file":"PromotionWidget.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.cardText {\n  overflow: auto;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-562d8b47","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PromotionWidget.vue
// module id = 661m
// module chunks = 15